/**
 * Helper function that resolves the promise after a given amount of time
 * @param {number} ms The milliseconds to wait before resolving
 */
export function delay(ms: number = 1) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}
